import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getLotteryItalyEndpoint } from 'services/lotteryItaly/lotteryItaly.config';
import { LotteryItaly } from 'services/lotteryItaly/lotteryItaly.types';

const initialState = {
  lotteryItaly: {} as Record<string, LotteryItaly>,
};
const lotteryItalyReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    const lotteryItaly = payload?.response?.data?.tickets;

    if (payload.resourceId === getLotteryItalyEndpoint) {
      if (Array.isArray(lotteryItaly)) {
        state.lotteryItaly = Object.fromEntries(
          lotteryItaly.map((LotteryItalyRecord: LotteryItaly, index) => [
            `${LotteryItalyRecord.drawId}_${index}`,
            LotteryItalyRecord,
          ]),
        );
      } else {
        state.lotteryItaly = {};
      }
    }
  }),
);

export default lotteryItalyReducer;
